'use strict';

/** @type {import('.')} */
module.exports = Error;



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-errors/index.js
 ** module id = 398
 ** module chunks = 35
 **/